import { use } from 'react'
import { TableEditorContext } from './TableEditorContext'
import type { TableEditorState } from './useTableEditor'

function useTableEditorContext(): TableEditorState {
  const ctx = use(TableEditorContext)
  if (!ctx) throw new Error('useTableEditorContext must be used within TableEditorProvider')
  return ctx
}

export { useTableEditorContext }
